<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      style="background:linear-gradient(0deg, #51357c 0%, #988fc3 100%);"
      :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')"
    >
      <div class="logo">
        <a href="" class="simple-text logo-mini">
          <img :src="logo" alt="app-logo" />
        </a>
        <a href="" class="simple-text logo-normal">
          Weedo Perf
        </a>
      </div>
      <slot></slot>
      <template slot-scope="props" slot="links">
        <sidebar-item
          :link="{
            name: $t('SidebarMenu.Dashboard'),
            icon: 'fas fa-desktop',
            path: '/myaffil/editeur/dashboard'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ 
            name: $t('SidebarMenu.ProgramList'), 
            icon: 'fa fa-bullhorn',
            path: '/myaffil/editeur/prgramslist'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ 
            name: $t('SidebarMenu.ShootsList'), 
            icon: 'fas fa-paper-plane',
            path: '/myaffil/editeur/MesShoots'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ 
            name: $t('SidebarMenu.CampaignsList'), 
            icon: 'tim-icons icon-bullet-list-67',
            path: '/myaffil/editeur/campagnelist'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{ 
            name: $t('SidebarMenu.SupportsList'), 
            icon: 'tim-icons icon-molecule-40',
            path: '/myaffil/editeur/supportslist'
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: $t('SidebarMenu.Statistics'),
            icon: 'fas fa-chart-line'
          }"
        >
          <sidebar-item
            :link="{ 
              name: $t('SidebarMenu.Global'),
              path: '/myaffil/editeur/stats/statsglobales'
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{ 
              name: 'par campagne',
              path: '/myaffil/editeur/stats/statscampagnes'
            }"
          >
          </sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->
    <sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share>
    <div class="main-panel" data="blue">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import SidebarShare from '../SidebarSharePlugin';
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from '../DashboardNavbar.vue';
import ContentFooter from '../ContentFooter.vue';
import DashboardContent from '../Content.vue';
import SidebarFixedToggleButton from '../SidebarFixedToggleButton.vue';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare
  },
  data() {
    return {
      logo: '/img/weedo-it-logo-blanc.png',
      sidebarBackground: 'orange' //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  mounted() {
    this.initScrollbar();
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
